import { DatePipe } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { NotificationModel } from 'src/app/models/class-notification.model';
import { CourseDTO } from 'src/app/models/course-dto.model';
import { CourseTrainingProgramDetails } from 'src/app/models/course-training-program-details.model';
import { CourseService } from 'src/app/services/course/course.service';
import { FormatUtil } from 'src/app/utils/format.util';
import { NotificationHtmlSanitizerService } from 'src/app/services/sanitization/notification-html-sanitizer.service';

@Component({
    selector: 'app-notifications-item',
    templateUrl: './notifications-item.component.html',
    styleUrls: ['./notifications-item.component.scss'],
    standalone: false
})
export class NotificationsItemComponent implements OnInit {
  formatUtil = FormatUtil;
  @Input() selectedNotification: NotificationModel;
  @Input() isMobileDetailPage: boolean;
  currentLang;
  courseDetails: CourseTrainingProgramDetails;
  showCourseDetails: boolean = false;



  constructor(
    @Inject('CourseService') public courseService: CourseService,
    public translateService: TranslateService,
    public notificationHtmlSanitizer: NotificationHtmlSanitizerService,
    public datePipe: DatePipe) {
    this.currentLang = translateService.currentLang;
    translateService.onLangChange.subscribe((lang) => this.currentLang = lang.lang);
  }

  trustHtml(content: string | null | undefined): SafeHtml {
    return this.notificationHtmlSanitizer.sanitize(content);
  }

  ngOnInit(): void {
      if (
        this.isMobileDetailPage &&
        this.selectedNotification.CourseId != null
      ) {
        this.courseService
          .GetCourseDetails(this.selectedNotification.CourseId)
          .subscribe((course) => {
            if (course != null) {
              this.courseDetails = course;
              this.showCourseDetails = true;
            }
          });
      }
  }
  getLocalTimeString(time: string) {
    if (time.indexOf('Z') == -1)
      time += 'Z'

    return this.datePipe.transform(time, "h:mm a")?.toUpperCase()
  }
}
